<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                © 2024 Swapify. All Rights Reserved.
            </div>
        </div>
    </div>
</footer>